import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import React, { Fragment } from "react";

export default function UserFreeTicket() {
  return (
    <Fragment>
      <Grid item md={6} sm={12} xs={12}>
        <Card className="card-wrapper">
          <CardContent style={{ padding: "0" }}>
            <Box className="card-top-section">
              <Box className="card-icon-top">
                <img src={"/images/reason02_circle.png"} />
              </Box>
              <Typography
                variant="h4"
                component="h4"
                className="classification-heading font-cur"
              >
                まずは無料でお悩み問診
              </Typography>
            </Box>
            <Box className="card-section-bottom">
              <Typography component={"h6"} className="sub-title">
                トラブルの原因がわからない方やどうしていいかわからない方は、まずはお電話でご相談ください。
              </Typography>
              <Typography
                style={{
                  marginBottom: "1rem",
                }}
              >
                専門相談員からの適切なチケットのご提案に加え、チケット購⼊から予約手順までご案内可能です。
              </Typography>
              <Box className="ticket-tel-number">
                <Typography>
                  <a href={`tel:050-3818-8719`}>
                    <img
                      src={"/images/phone-icon.png"}
                      alt=""
                      className="phone-icon"
                    />
                    <span>050-3818-8719</span>
                  </a>
                </Typography>
              </Box>
              <Typography
                style={{ textAlign: "center", color: "var(--dark-grey)" }}
              >
                ※お客様の環境によって別途通話料がかかる場合がございます。
              </Typography>
            </Box>
          </CardContent>
        </Card>
        {/* {showButton && (
            <Grid
              container
              className="home-ticket-wrapper"
              alignItems="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid item md={3} sm={3} xs={3}>
                <img
                  src={`/images/interview-image-free.png`}
                  alt=""
                  className="ticket-image"
                />
              </Grid>
              <Grid item md={9} sm={9} xs={9} className="home-ticket-details">
                <Typography
                  component={"h5"}
                  variant={"h5"}
                  className="classification-heading"
                >
                  {ticket.productName}
                </Typography>
                {ticket.interviewTelNumber && (
                  <Typography className="home-interview-number">
                    <img
                      src={"/images/phone-icon.png"}
                      alt=""
                      className="phone-icon"
                    />
                    {ticket.interviewTelNumber}
                  </Typography>
                )}
                <Typography
                  variant="h6"
                  component={"h6"}
                  className="bold-accent"
                >
                  チケット番号: {ticket.ticketNumber}
                </Typography>
              </Grid>
            </Grid>
          )} */}
      </Grid>
    </Fragment>
  );
}
